import { createAction, createAsyncAction } from '@/redux/root';

export const nameSpace = '@@/aspyn-migrator';

export const pushToAspynAsync = createAsyncAction(`${nameSpace}/PUSH_TO_ASPYN`);

export const pushHousingToAspynAsync = createAsyncAction(`${nameSpace}/PUSH_HOUSING_TO_ASPYN`);

export const seedPrerequisiteEntitiesAsync = createAsyncAction(`${nameSpace}/SEED_PREREQUISITE_ENTITIES`);

export const clearCacheOfAspynPushesAsync = createAsyncAction(`${nameSpace}/CLEAR_CACHE_OF_ASPYN_PUSHES`);

export const requestMigrationJobsAsync = createAsyncAction(`${nameSpace}/REQUEST_MIGRATION_JOBS`);

export const migrateRepsAsync = createAsyncAction(`${nameSpace}/MIGRATE_REPS`);

export const clearAspynResultAction = createAction(`${nameSpace}/CLEAR_ASPYN_RESULT`);

export const clearAspynHousingResultAction = createAction(`${nameSpace}/CLEAR_ASPYN_HOUSING_RESULT`);
